/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Everything is computed in your browser and nothing is uploaded.`)
};

const es_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Todo se calcula en tu navegador y nada se sube a ningún servidor.`)
};

const de_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Alles wird in Ihrem Browser berechnet, und nichts wird hochgeladen.`)
};

const nl_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Alles wordt in je browser berekend en niets wordt geüpload.`)
};

const fr_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Tout est calculé dans votre navigateur et rien n'est téléversé.`)
};

const it_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Tutto viene calcolato nel tuo browser e nulla viene caricato altrove.`)
};

const pt_br2_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Tudo é calculado no seu navegador e nada é enviado para servidores.`)
};

const pt_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Tudo é calculado no seu navegador e nada é enviado.`)
};

const ja_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。すべてブラウザ内で計算され、アップロードは行われません。`)
};

const zh_bubble_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会的。所有计算都在你的浏览器中完成，不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_a4", locale)
	if (locale === "en") return en_bubble_faq_a4(inputs)
	if (locale === "es") return es_bubble_faq_a4(inputs)
	if (locale === "de") return de_bubble_faq_a4(inputs)
	if (locale === "nl") return nl_bubble_faq_a4(inputs)
	if (locale === "fr") return fr_bubble_faq_a4(inputs)
	if (locale === "it") return it_bubble_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_a4(inputs)
	if (locale === "pt") return pt_bubble_faq_a4(inputs)
	if (locale === "ja") return ja_bubble_faq_a4(inputs)
	return zh_bubble_faq_a4(inputs)
};